/**
 * WalkAndPunch API
 * This is the WalkAndPunch API
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface InspectionAuditViewModel { 
    projectId?: number;
    templateId?: number;
    date?: string;
    userEmail?: string;
    userFullName?: string;
    action?: string;
    remarks?: string;
    inspectionName?: string;
}